/**
 * Chilean peso.
 */
export var CLP = {
  code: 'CLP',
  base: 10,
  exponent: 0
};